import Navbar from "components/Navbar/Navbar";
import Sidebar from "components/Sidebar/Sidebar";
/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import type React from "react";
import { useState } from "react";
import { PrivacyProvider } from "../../reducers/privacy";
import AdminRoutes from "../../routes/adminRoutes";
import CompanyListGate from "./CompanyListGate";
import PrivacyModeInit from "./PrivacyModeInit";
import SchemeListGate from "./SchemeListGate";

const Admin = (): React.ReactElement => {
  const sidebarState = useState(false);

  return (
    <CompanyListGate>
      <PrivacyProvider>
        <PrivacyModeInit>
          <div>
            <Sidebar sidebarState={sidebarState} />
            <div className="xl:pl-72">
              <Navbar sidebarState={sidebarState} />
              <main className="py-4 max-w-screen-2xl mx-auto">
                <div className="px-4 sm:px-6 lg:px-8">
                  {/* Gate only the routed content while a deep-linked scheme
                      resolves — the sidebar/navbar (and their selectors) stay
                      mounted, so a company switch never blanks the chrome. */}
                  <SchemeListGate>
                    <AdminRoutes />
                  </SchemeListGate>
                </div>
              </main>
            </div>
          </div>
        </PrivacyModeInit>
      </PrivacyProvider>
    </CompanyListGate>
  );
};

export default Admin;
